import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
const { create, ...generic_actions } = genericStore.actions;
export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "send_notifications",
    object: "send_notification",
    header: [
      { text: "Date", value: "date" },
      { text: "Title", value: "title" },
      { text: "Body", value: "body" },
      { text: "Hora", value: "hour" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...generic_actions,
    create({ commit, state }, data) {
      let saveData = {};
      const users = data.users || [];
      delete data.users;
      saveData[state.object] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        const formData = jsonToFormData(saveData, {
          arrayIndexes: false,
          excludeNull: true,
        });
        formData.append("send_notification[users]", users);
        axios
          .post(config.api_url + state.endpoint, formData, {
            headers: {
              "Content-Type": "application/json",
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            commit("success");
            resolve(response.data);
          })
          .catch((error) => {
            commit("error");
            reject(error.response.data);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
